import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getJobsError, isJobsReadyOrError } from '../../selectors';
import DepartmentJobs from './DepartmentJobs';
import Loading from './Loading';
import Empty from './Empty';
import Error from './Error';

const Jobs = ({
  greenhouse,
  ready,
  error,
  hasJobs,
}) => (
  <>
    { !ready && !error && (
      <Loading />
    )}

    { ready && !error && !hasJobs && (
      <Empty title="No jobs available" description="Unfortunately there are no jobs available that match your selected filters. Please check and try again." />
    )}

    { ready && error && (
      <Error />
    )}

    { !error && (
      <div>
        { greenhouse.jobs.value.map(departmentJobs => (
          <DepartmentJobs departmentJobs={departmentJobs} key={departmentJobs.departmentId} />
        ))}
      </div>
    )}
  </>
);

Jobs.propTypes = {
  ready: PropTypes.bool.isRequired,
  error: PropTypes.string,
  hasJobs: PropTypes.bool.isRequired,
  greenhouse: PropTypes.shape({
    jobs: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.shape({
        departmentId: PropTypes.number.isRequired,
        departmentName: PropTypes.string.isRequired,
        jobs: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            location: PropTypes.string.isRequired,
          }),
        ),
        children: PropTypes.arrayOf(PropTypes.shape({
          departmentId: PropTypes.number.isRequired,
          departmentName: PropTypes.string.isRequired,
          jobs: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number.isRequired,
              title: PropTypes.string.isRequired,
              url: PropTypes.string.isRequired,
              location: PropTypes.string.isRequired,
            }),
          ),
        })),
      })).isRequired,
    }),
  }).isRequired,
};

Jobs.defaultProps = {
  error: undefined,
};

const mapStateToProps = state => ({
  ...state,
  ready: isJobsReadyOrError(state),
  error: getJobsError(state),
  hasJobs: state.greenhouse.jobs.value.length > 0,
});

export default connect(mapStateToProps)(Jobs);
